let allVehicleData = [];
let filterTimeout;

const fieldMapping = {
    'Year': ['Year', 'Y'],
    'Make': ['Make', 'M'],
    'Model': ['Model', 'Mo'],
    'Trim': ['Trim', 'T'],
    'Engine': ['Engine', 'E']
};

async function loadAndBuildTable() {
    try {
        const table = document.querySelector('#vehicleCompatibilityTable'); // 获取整个表格
        const tableBody = table ? table.querySelector('tbody') : null;

        if (!tableBody) {
            console.warn("Table element '#vehicleCompatibilityTable tbody' not found on this page. Skipping vehicle data loading.");
            return; // Exit if the table body isn't found
        }
      
        const productIdsUsingJSON = [8995972481275]; 
        const currentProductId = Shopify?.product?.id;
      
      if (productIdsUsingJSON.includes(currentProductId)) {
        console.log('Using external JSON file for vehicle data.');
        try {
        const response = await fetch('https://cdn.shopify.com/s/files/1/0174/0609/9556/files/CE07-00006BK-000-W_data.json?v=1751610924');
        if (!response.ok) throw new Error('Failed to load JSON');
        allVehicleData = await response.json();
        } catch (e) {
        console.error('Failed to load external JSON:', e);
        tableBody.innerHTML = `<tr><td colspan="5" class="no-results-message">Failed to load vehicle data. Please try again later.</td></tr>`;
        return;
        }
      } else if (window.currentProductVehicleData) {
            if (typeof window.currentProductVehicleData === 'string') {
                try {
                    window.currentProductVehicleData = JSON.parse(window.currentProductVehicleData);
                } catch (e) {
                    console.error('Failed to parse vehicle data JSON:', e);
                    window.currentProductVehicleData = null;
                }
            }
            allVehicleData = window.currentProductVehicleData;
        } else {
            console.warn("No vehicle data found in metafield for this product.");
            const initialColCount = table.querySelector('thead tr') ? table.querySelector('thead tr').children.length : 5;
            tableBody.innerHTML = `<tr><td colspan="${initialColCount}" class="no-results-message">No vehicle data available for this product.</td></tr>`;
            return;
        }

        tableBody.innerHTML = '';

        const tableHead = table.querySelector('thead tr');
        let activeHeaders = [];
        if (tableHead) {
            Array.from(tableHead.children).forEach(th => {
                activeHeaders.push(th.textContent.trim());
            });
        }
        if (activeHeaders.length === 0) {
            activeHeaders = ['Year', 'Make', 'Model', 'Trim', 'Engine'];
        }

allVehicleData.forEach(rowData => {
    const row = tableBody.insertRow();
    activeHeaders.forEach(header => {
        const cell = row.insertCell();

        // 尝试使用字段映射取值
        const possibleKeys = fieldMapping[header] || [header];
        let value = '';
        for (const key of possibleKeys) {
            if (rowData[key] !== undefined && rowData[key] !== null) {
                value = String(rowData[key]);
                break;
            }
        }

        cell.textContent = value;
    });
});

        populateDropdowns();
        debounceFilter();

        console.log("Vehicle data loaded and table built.");

    } catch (error) {
        console.error("Error loading vehicle data:", error);
        const tableBody = document.querySelector('#vehicleCompatibilityTable tbody');
        const errorColCount = document.querySelector('#vehicleCompatibilityTable thead tr') ? document.querySelector('#vehicleCompatibilityTable thead tr').children.length : 5;
        if (tableBody) {
            tableBody.innerHTML = `<tr><td colspan="${errorColCount}" class="no-results-message">Failed to load vehicle data. Please try again later.</td></tr>`;
        }
    }
}

function populateDropdowns() {
    if (!Array.isArray(allVehicleData) || allVehicleData.length === 0) {
        return;
    }

    const getMappedValue = (item, header) => {
        const possibleKeys = fieldMapping[header] || [header];
        for (const key of possibleKeys) {
            if (item[key]) return item[key];
        }
        return '';
    };

    const uniqueYears = [...new Set(allVehicleData.map(item => getMappedValue(item, 'Year')).filter(Boolean))].sort((a, b) => b - a);
    const yearSelect = document.getElementById('filterYear');
    if (yearSelect) {
        yearSelect.innerHTML = '<option value="">Year (All)</option>';
        uniqueYears.forEach(year => {
            const option = document.createElement('option');
            option.value = year;
            option.textContent = year;
            yearSelect.appendChild(option);
        });
    }

    const uniqueMakes = [...new Set(allVehicleData.map(item => getMappedValue(item, 'Make')).filter(Boolean))].sort();
    const makeSelect = document.getElementById('filterMake');
    if (makeSelect) {
        makeSelect.innerHTML = '<option value="">Make (All)</option>';
        uniqueMakes.forEach(make => {
            const option = document.createElement('option');
            option.value = make;
            option.textContent = make;
            makeSelect.appendChild(option);
        });
    }
}


function filterTable() {
    const filterYear = document.getElementById('filterYear') ? document.getElementById('filterYear').value.toLowerCase().trim() : '';
    const filterMake = document.getElementById('filterMake') ? document.getElementById('filterMake').value.toLowerCase().trim() : '';
    const filterModel = document.getElementById('filterModel') ? document.getElementById('filterModel').value.toLowerCase().trim() : '';
    const filterTrim = document.getElementById('filterTrim') ? document.getElementById('filterTrim').value.toLowerCase().trim() : '';
    const filterEngine = document.getElementById('filterEngine') ? document.getElementById('filterEngine').value.toLowerCase().trim() : '';

    const tableBody = document.querySelector('#vehicleCompatibilityTable tbody');
    if (!tableBody) return;

    const tableHead = document.querySelector('#vehicleCompatibilityTable thead tr');
    const currentVisibleColCount = tableHead ? tableHead.children.length : 0;

    const rows = tableBody.getElementsByTagName('tr');
    let matchCount = 0;

    for (let i = 0; i < rows.length; i++) {
        const row = rows[i];
        if (row.id === 'loadErrorRow' || row.id === 'noResultsRow' || row.querySelector('.loading-message') || row.querySelector('.no-results-message')) {
            row.classList.add('no-match');
            continue;
        }

        const cells = row.getElementsByTagName('td');
        if (cells.length < (currentVisibleColCount || 5)) {
            row.classList.add('no-match');
            continue;
        }

        const rowData = {};
        const headers = Array.from(document.querySelectorAll('#vehicleCompatibilityTable thead th')).map(th => th.textContent.trim());

        headers.forEach((header, index) => {
            if (cells[index]) {
                rowData[header] = cells[index].textContent.toLowerCase();
            } else {
                rowData[header] = '';
            }
        });

        let match = true;

        if (filterYear && !rowData.Year.includes(filterYear)) {
            match = false;
        }
        if (filterMake && !rowData.Make.includes(filterMake)) {
            match = false;
        }
        if (filterModel && !rowData.Model.includes(filterModel)) {
            match = false;
        }
        if (filterTrim && !rowData.Trim.includes(filterTrim)) {
            match = false;
        }
        if (filterEngine && rowData.Engine && !rowData.Engine.includes(filterEngine)) {
            match = false;
        }

        if (match) {
            row.classList.remove('no-match');
            matchCount++;
        } else {
            row.classList.add('no-match');
        }
    }

    let noResultsRow = document.getElementById('noResultsRow');
    if (matchCount === 0) {
        if (!noResultsRow) {
            noResultsRow = tableBody.insertRow();
            noResultsRow.id = 'noResultsRow';
            noResultsRow.innerHTML = `<td colspan="${currentVisibleColCount || 5}" class="no-results-message">No matching vehicles found.</td>`;
        } else {
            noResultsRow.classList.remove('no-match');
        }
    } else {
        if (noResultsRow) {
            noResultsRow.remove();
        }
    }
}


function debounceFilter() {
    clearTimeout(filterTimeout);
    filterTimeout = setTimeout(() => {
        filterTable();
    }, 300);
}

// 新增：为筛选框绑定监听事件，触发筛选（带防抖）
function addFilterListeners() {
    const filterIds = ['filterYear', 'filterMake', 'filterModel', 'filterTrim', 'filterEngine'];
    filterIds.forEach(id => {
        const elem = document.getElementById(id);
        if (elem) {
            elem.addEventListener('input', debounceFilter);
            elem.addEventListener('change', debounceFilter);
        }
    });
}

document.addEventListener('DOMContentLoaded', () => {
    loadAndBuildTable();
    addFilterListeners();
});
